import { createSelector } from 'reselect';
import MrdXmlDailyAnalysisColumns
  from '../../containers/MrdXmlDailyAnalysisColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .MRD_XML_DAILY_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .MRD_XML_DAILY_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions
    .MRD_XML_DAILY_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, MrdXmlDailyAnalysisColumns);
